module.exports = __webpack_public_path__ + "static/media/advanced_reporting.9c5c7fc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/advanced_reporting.svg
// module id = 150
// module chunks = 0